import styled from "styled-components"

export const BlockQuote = styled.blockquote`
  width: 80%;
  margin: 2.5rem auto;
  padding: 0.5rem 1.5rem;
  border-left: 10px solid hsl(45, 100%, 55.00%);
  font-size: 1.25rem;
  font-family: Lato,Verdana,sans-serif;
  font-weight: 600;
`